import { values } from './enums'

const _enum = {
  None: 0,
  Success: 1,
  MissingValidPublicKeyForCurrentUser: 2,
  MissingValidSystemRsaKey: 3,
  InvalidSignature: 4,
  Failure: 5
}

export const xmlValidationResult = {
  enumName: 'XmlValidationResult',
  enum: _enum,
  values: values(_enum)
}



// WEBPACK FOOTER //
// ./src/enums/xmlValidationResult.js